import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { BackResponse, BackResponseFailure, SellerSummary } from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.config}user/sellers`;

export const getAuthorizedSellersRequest = (): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getAuthorizedSellersQuery = async (): Promise<
  BackResponse<SellerSummary[]> | BackResponseFailure
> => {
  try {
    return await executeQuery<BackResponse<SellerSummary[]>>(
      getAuthorizedSellersRequest(),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
